var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['box', `box--align-${_vm.align}`]},[_c('div',{staticClass:"icon"},[_vm._t("default")],2),_c('typography',{staticClass:"text",attrs:{"bold":_vm.bold,"type":_vm.textType,"align":_vm.align}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }